import { OptionValue } from 'types/common';
import { SettingsResponse } from 'types/profile';
import * as Yup from 'yup';
import {
  AGE_RANGE_VALIDATOR,
  PAYPAL_EMAIL_VALIDATOR,
  SOCIALS_VALIDATOR,
} from './validation';

export type SettingsFormikValues = Omit<
  SettingsResponse,
  'jobTypes' | 'address' | 'creatorId' | 'userId'
>;

export const initialSettingsFormValues: SettingsFormikValues = {
  profilePicture: '',
  firstName: '',
  lastName: '',
  username: '',
  about: '',
  ageRange: undefined,
  payPalEmail: '',
  socials: {
    instagram: '',
    tikTok: '',
    youTube: '',
    website: '',
  },
  //   creatorCategories: {},
  //   creatorSkills: {},
  socialCategories: [],
  contentCategories: [],
  equipment: [],
  environment: [],
};

// export const SettingsValidationSchema: Yup.ObjectSchema<SettingsFormikValues> =
export const SettingsValidationSchema = Yup.object().shape({
  profilePicture: Yup.string(),
  firstName: Yup.string(),
  lastName: Yup.string(),
  about: Yup.string(),
  username: Yup.string(),
  ageRange: AGE_RANGE_VALIDATOR,
  payPalEmail: PAYPAL_EMAIL_VALIDATOR,
  socials: SOCIALS_VALIDATOR,
  socialCategories: Yup.array(), // CREATOR_CATEGORIES_VALIDATOR,
  contentCategories: Yup.array(), // CREATOR_SKILLS_VALIDATOR,
  equipment: Yup.array(),
  environment: Yup.array(),
}); // Could check that keys match Record<keyof ..., any>

const SETTINGS_TAB_IDS = [
  'basics',
  'categories',
  'skills',
  'equipment',
  'environment',
  'social-media-accounts',
  'paypal-email',
  //   "login-email",
  'privacy-policy',
  'terms-of-service',
] as const;

export type SettingsTabId = typeof SETTINGS_TAB_IDS[number];

export const SETTINGS_TABS: OptionValue<SettingsTabId> = [
  {
    value: 'basics',
    label: 'Basics',
  },
  {
    value: 'categories',
    label: 'Categories',
  },
  {
    value: 'skills',
    label: 'Skills',
  },
  {
    value: 'equipment',
    label: 'Equipment',
  },
  {
    value: 'environment',
    label: 'Environment',
  },
  {
    value: 'social-media-accounts',
    label: 'Social Media Accounts',
  },
  {
    value: 'paypal-email',
    label: 'PayPal Email',
  },
  //   {
  //     value: "login-email",
  //     label: "Login Email",
  //   },
  {
    value: 'privacy-policy',
    label: 'Privacy Policy',
  },
  {
    value: 'terms-of-service',
    label: 'Terms of Service',
  },
];
